import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-privacy',
  standalone: false,
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})

export class PrivacyComponent {
  
  currentYear: number = new Date().getFullYear();

  constructor() {}
}
